/* ===== Event messages (admin dashboard) ===== */
import { db } from '../config/firebase.js?v=83.79';
import { getCurrentUser } from './auth.js?v=83.79';
import {
  markEventMessageReadBackend
} from './backend.js?v=83.79';
import { logger } from '../utils/logger.js?v=83.79';
import { formatFirestoreDateRo, $, logFirestoreAccessDeniedOnce } from '../utils/helpers.js?v=83.79';
import { showSnackbar } from '../utils/ui.js?v=83.79';
import { loadScriptOnce } from '../utils/lazy-loader.js?v=83.79';
import { getCurrentSettings } from './settings.js?v=83.79';

let eventMessagesUnsub = null;
let lastEventMessagesRows = [];
let isDeletingAllEventMessages = false;

async function deleteEventMessageDoc(messageId) {
  const currentUser = getCurrentUser();
  if (!currentUser || !messageId) throw new Error('Operațiune invalidă');
  await db.collection('eventMessages').doc(messageId).delete();
}

async function deleteAllEventMessageDocs() {
  const currentUser = getCurrentUser();
  if (!currentUser) throw new Error('Nu ești logat');

  const snap = await db.collection('eventMessages').where('merchantUid', '==', currentUser.uid).get();
  if (snap.empty) return 0;

  const BATCH_LIMIT = 500;
  let deletedCount = 0;
  for (let i = 0; i < snap.docs.length; i += BATCH_LIMIT) {
    const batch = db.batch();
    const docsBatch = snap.docs.slice(i, i + BATCH_LIMIT);
    docsBatch.forEach((doc) => batch.delete(doc.ref));
    await batch.commit();
    deletedCount += docsBatch.length;
  }
  return deletedCount;
}

export function getLastEventMessagesRows() {
  return lastEventMessagesRows;
}

export function stopEventMessagesListener() {
  if (eventMessagesUnsub) {
    try {
      eventMessagesUnsub();
    } catch (_) {
      /* ignore */
    }
    eventMessagesUnsub = null;
  }
}

function statusLabel(status) {
  return status === 'read' ? 'Citit' : 'Nou';
}

function sourceLabel(source) {
  const raw = String(source || '').toLowerCase();
  if (raw === 'public-client') return 'Client public';
  if (raw === 'tablet') return 'Tabletă';
  if (raw === 'client') return 'Client';
  return source || '—';
}

export function renderRecentEventMessages(rows) {
  const container = document.getElementById('dashboardEventMessagesList');
  if (!container) return;
  container.replaceChildren();

  if (!rows || rows.length === 0) {
    const emptyMsg = document.createElement('div');
    emptyMsg.className = 'dashboard-empty-state';
    emptyMsg.textContent = 'Încă nu există mesaje pentru eveniment.';
    container.appendChild(emptyMsg);
    return;
  }

  rows.slice(0, 5).forEach((msg) => {
    const text = String(msg.text || '').trim();
    const preview = text.length > 80 ? `${text.slice(0, 80)}…` : text || '—';
    const dateTimeStr = formatFirestoreDateRo(msg.createdAt);
    const status = statusLabel(msg.status);

    const item = document.createElement('div');
    item.className = 'dashboard-claim-item';

    const avatar = document.createElement('div');
    avatar.className = 'dashboard-claim-avatar';
    avatar.textContent = '💬';

    const info = document.createElement('div');
    info.className = 'dashboard-claim-info';

    const nameDiv = document.createElement('div');
    nameDiv.className = 'dashboard-claim-name';
    nameDiv.textContent = preview;

    const statusDiv = document.createElement('div');
    statusDiv.className = 'dashboard-claim-email';
    statusDiv.textContent = status;

    info.appendChild(nameDiv);
    info.appendChild(statusDiv);

    const timeDiv = document.createElement('div');
    timeDiv.className = 'dashboard-claim-time';
    timeDiv.textContent = dateTimeStr;

    item.appendChild(avatar);
    item.appendChild(info);
    item.appendChild(timeDiv);
    container.appendChild(item);
  });
}

let eventMsgFilter = 'all';

function msgDate(v) {
  try {
    if (!v) return null;
    if (typeof v.toDate === 'function') return v.toDate();
    if (typeof v.toMillis === 'function') return new Date(v.toMillis());
    if (v.seconds) return new Date(v.seconds * 1000);
    const d = new Date(v);
    return isNaN(d.getTime()) ? null : d;
  } catch (_) { return null; }
}

function msgWhen(d) {
  if (!d) return '';
  const day = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const n = new Date();
  const today = new Date(n.getFullYear(), n.getMonth(), n.getDate()).getTime();
  const hm = d.toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' });
  if (day === today) return `azi, ${hm}`;
  if (day === today - 864e5) return `ieri, ${hm}`;
  return `${d.toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit' })}, ${hm}`;
}

function msgSourceText(source) {
  const raw = String(source || '').toLowerCase();
  if (raw === 'public-client') return 'din pagina publică';
  if (raw === 'tablet') return 'de pe tabletă';
  if (raw === 'client') return 'de la client';
  return '';
}

const SVG_NS = 'http://www.w3.org/2000/svg';
function msgIcon(paths, size = 16, color) {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('width', size); svg.setAttribute('height', size); svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', color || 'currentColor'); svg.setAttribute('stroke-width', '2.3');
  svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round'); svg.setAttribute('aria-hidden', 'true');
  paths.forEach((d) => { const p = document.createElementNS(SVG_NS, 'path'); p.setAttribute('d', d); svg.appendChild(p); });
  return svg;
}
const ICON_CHECK = ['M5 12.5l4.5 4.5L19 7.5'];
const ICON_TRASH = ['M4 7h16', 'M10 11v6M14 11v6', 'M6 7l1 13h10l1-13', 'M9 7V4h6v3'];

function sjmEl(tag, cls, text) {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (text != null) e.textContent = text;
  return e;
}

/** Mesajele invitaților: carduri; filtre Toate / Noi / Citite. */
export function renderEventMessagesInModal(rows) {
  const list = document.getElementById('eventMessagesList');
  if (!list) return;
  const all = rows || [];
  const unread = all.filter((r) => r.status !== 'read').length;
  const readN = all.length - unread;

  const sub = document.getElementById('eventMessagesSub');
  if (sub) {
    let title = '';
    try { title = String(getCurrentSettings()?.eventModule?.title || '').trim(); } catch (_) { /* ignore */ }
    const counts = all.length ? `${all.length} ${all.length === 1 ? 'mesaj' : 'mesaje'}${unread ? `, ${unread} ${unread === 1 ? 'nou' : 'noi'}` : ''}` : 'Niciun mesaj';
    sub.textContent = title ? `${title} · ${counts}` : counts;
  }
  const chips = document.getElementById('eventMessagesFilters');
  if (chips) {
    const labels = { all: `Toate · ${all.length}`, new: `Noi · ${unread}`, read: `Citite · ${readN}` };
    chips.querySelectorAll('[data-filter]').forEach((b) => {
      const f = b.dataset.filter;
      b.textContent = labels[f];
      const on = f === eventMsgFilter;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  const filtered = all.filter((r) => (eventMsgFilter === 'new' ? r.status !== 'read' : eventMsgFilter === 'read' ? r.status === 'read' : true));
  list.replaceChildren();
  if (!filtered.length) {
    list.appendChild(sjmEl('p', 'sjm-empty', eventMsgFilter === 'new' ? 'Niciun mesaj nou.' : eventMsgFilter === 'read' ? 'Niciun mesaj citit.' : 'Încă nu a scris nimeni.'));
    return;
  }

  filtered.forEach((r) => {
    const isNew = r.status !== 'read';
    const card = sjmEl('article', `sjm-card${isNew ? ' is-new' : ''}`);
    const meta = sjmEl('div', 'sjm-meta');
    if (isNew) {
      meta.appendChild(sjmEl('span', 'sjm-dot'));
      meta.appendChild(sjmEl('b', 'sjm-new', 'Nou'));
    } else {
      meta.appendChild(msgIcon(ICON_CHECK, 14, '#1F7A4D'));
      meta.appendChild(sjmEl('span', 'sjm-read', 'Citit'));
    }
    const bits = [msgWhen(msgDate(r.createdAt)), msgSourceText(r.source)].filter(Boolean);
    if (bits.length) meta.appendChild(sjmEl('span', 'sjm-when', `· ${bits.join(' · ')}`));
    meta.appendChild(sjmEl('span', 'sjm-grow'));

    const del = sjmEl('button', 'sjm-del');
    del.type = 'button';
    del.setAttribute('aria-label', 'Șterge mesajul');
    del.title = 'Șterge mesajul';
    del.appendChild(msgIcon(ICON_TRASH, 17));
    del.addEventListener('click', async () => {
      if (!window.confirm('Ștergi acest mesaj?')) return;
      del.disabled = true;
      try {
        await deleteEventMessageDoc(r._id);
        showSnackbar('Mesaj șters.');
      } catch (e) {
        logger.error('[eventMessages] delete failed', e);
        showSnackbar('Eroare: ' + (e?.message || 'necunoscută'), 'error');
      } finally {
        del.disabled = false;
      }
    });
    meta.appendChild(del);
    card.appendChild(meta);

    card.appendChild(sjmEl('p', 'sjm-text', String(r.text || '')));

    if (isNew) {
      const read = sjmEl('button', 'sjm-readbtn');
      read.type = 'button';
      read.appendChild(msgIcon(ICON_CHECK, 16));
      read.appendChild(document.createTextNode('Am citit'));
      read.addEventListener('click', async () => {
        read.disabled = true;
        try {
          await markEventMessageReadBackend({ messageId: r._id });
          showSnackbar('Mesaj marcat ca citit.');
        } catch (e) {
          logger.error('[eventMessages] mark read failed', e);
          showSnackbar('Eroare: ' + (e?.message || 'necunoscută'), 'error');
          read.disabled = false;
        }
      });
      card.appendChild(read);
    }
    list.appendChild(card);
  });
}

export function startEventMessagesListener() {
  const currentUser = getCurrentUser();
  if (!currentUser) return;

  stopEventMessagesListener();

  const q = db.collection('eventMessages').where('merchantUid', '==', currentUser.uid);
  bindEventMessagesSearch();

  eventMessagesUnsub = q.onSnapshot(
    (snap) => {
      const rows = [];
      snap.forEach((d) => {
        const r = d.data() || {};
        r._id = d.id;
        rows.push(r);
      });
      rows.sort((a, b) => {
        const ta = a.createdAt?.toMillis?.() ?? 0;
        const tb = b.createdAt?.toMillis?.() ?? 0;
        return tb - ta;
      });
      lastEventMessagesRows = rows;
      renderRecentEventMessages(rows);

      import('../ui/mod-client-modules.js?v=83.79')
        .then((m) => m.updateModClientModulesUI?.())
        .catch(() => {});

      const modal = document.getElementById('eventMessagesModal');
      if (modal?.classList.contains('active')) {
        renderEventMessagesInModal(rows);
      }
    },
    (err) => {
      logFirestoreAccessDeniedOnce('eventMessages', err);
    }
  );
}

export function refreshEventMessages() {
  renderRecentEventMessages(lastEventMessagesRows || []);
  const modal = document.getElementById('eventMessagesModal');
  if (modal?.classList.contains('active')) {
    renderEventMessagesInModal(lastEventMessagesRows || []);
  }
  showSnackbar('Lista mesajelor este actualizată.');
}

export async function exportEventMessages() {
  const currentUser = getCurrentUser();
  if (!currentUser) return showSnackbar('Nu ești logat');

  try {
    await loadScriptOnce('https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js', 'XLSX', 8000);
    if (!window.XLSX) {
      throw new Error('XLSX nu este disponibil');
    }

    const snap = await db.collection('eventMessages').where('merchantUid', '==', currentUser.uid).get();
    if (snap.empty) {
      showSnackbar('Niciun mesaj de exportat');
      return;
    }

    const rows = [['Nr.', 'Data', 'Mesaj', 'Status', 'Sursă']];
    let rowNum = 0;
    const docs = snap.docs
      .map((d) => ({ id: d.id, ...(d.data() || {}) }))
      .sort((a, b) => {
        const ta = a.createdAt?.toMillis?.() ?? 0;
        const tb = b.createdAt?.toMillis?.() ?? 0;
        return tb - ta;
      });

    docs.forEach((msg) => {
      rowNum += 1;
      rows.push([
        rowNum,
        formatFirestoreDateRo(msg.createdAt),
        msg.text || '',
        statusLabel(msg.status),
        sourceLabel(msg.source)
      ]);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(rows);
    XLSX.utils.book_append_sheet(wb, ws, 'Mesaje eveniment');

    const filename = `mesaje_eveniment_${currentUser.uid}_${new Date().toISOString().slice(0, 10)}.xlsx`;
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
    a.remove();

    showSnackbar('Excel descărcat.');
  } catch (e) {
    logger.error('[exportEventMessages]', e);
    showSnackbar('Eroare export: ' + (e?.message || 'necunoscută'), 'error');
  }
}

export function openDeleteAllEventMessagesModal() {
  const modal = document.getElementById('deleteAllEventMessagesModal');
  if (modal) modal.classList.add('active');
}

export function closeDeleteAllEventMessagesModal() {
  const modal = document.getElementById('deleteAllEventMessagesModal');
  if (modal) modal.classList.remove('active');
}

export function resetEventMessages() {
  const currentUser = getCurrentUser();
  if (!currentUser) return showSnackbar('Nu ești logat');
  openDeleteAllEventMessagesModal();
}

export async function confirmDeleteAllEventMessages() {
  if (isDeletingAllEventMessages) return;

  const currentUser = getCurrentUser();
  if (!currentUser) return showSnackbar('Nu ești logat');

  const btn = $('confirmDeleteAllEventMessagesBtn');
  const originalText = btn ? btn.textContent : 'Da, șterge mesajele';

  isDeletingAllEventMessages = true;
  if (btn) {
    btn.disabled = true;
    btn.style.pointerEvents = 'none';
    btn.classList.add('btn-disabled-state');
    btn.innerHTML = '<span class="inline-spinner"></span> Ștergere în curs...';
  }

  try {
    const deletedCount = await deleteAllEventMessageDocs();
    closeDeleteAllEventMessagesModal();
    showSnackbar(
      deletedCount > 0
        ? `${deletedCount} mesaje șterse cu succes.`
        : 'Niciun mesaj de șters.'
    );
  } catch (e) {
    logger.error('[confirmDeleteAllEventMessages]', e);
    showSnackbar('Eroare la ștergere: ' + (e?.message || 'necunoscută'), 'error');
    if (btn) {
      btn.disabled = false;
      btn.style.pointerEvents = '';
      btn.classList.remove('btn-disabled-state');
      btn.textContent = originalText;
    }
  } finally {
    isDeletingAllEventMessages = false;
  }
}

export function openEventMessagesModal() {
  const modal = document.getElementById('eventMessagesModal');
  if (!modal) return;
  bindEventMessagesSearch();
  eventMsgFilter = 'all';
  modal.classList.add('active');
  renderEventMessagesInModal(lastEventMessagesRows || []);
}

export function closeEventMessagesModal() {
  const modal = document.getElementById('eventMessagesModal');
  if (modal) modal.classList.remove('active');
}

export function bindEventMessagesSearch() {
  const box = document.getElementById('eventMessagesFilters');
  if (!box || box.dataset.bound === '1') return;
  box.addEventListener('click', (e) => {
    const b = e.target.closest('[data-filter]');
    if (!b) return;
    eventMsgFilter = b.dataset.filter;
    renderEventMessagesInModal(lastEventMessagesRows || []);
  });
  box.dataset.bound = '1';
}
